/**
 * This file is used as a template in index html generation,
 * please test v2 standalone initial loading indicator when making
 * changes here.
 */

/* eslint-disable */
export const getLoaderTemplate = (opacityClass: string, customTextContentClass?: string) => {
  return `<div class="rdLoadingIndicator ${opacityClass}">
    <div class="rdLoadWrap">
        <div class="rdCircle"></div>
        <div class="rdCircle"></div>
        <div class="rdCircle"></div>
    </div>
    <div class="rdLoadingText ${customTextContentClass}" id="data-loading-text" aria-hidden="true"></div>
</div>`;
};
